{
  "nl": {
    "classroomScreen": {
      "buttons": {
        "annotate": "Tekenen",
        "cardActions": "Acties",
        "clearAllDrawings": "Alle tekeningen verwijderen",
        "eraser": "Gum",
        "pencil": "Pen",
        "marker": "Markeerstift",
        "continue": "Verder",
        "createQrCode": "QR-code genereren",
        "customTime": "Andere timer",
        "delete": "Verwijderen",
        "deleteCard": "Kaart verwijderen",
        "drawTicket": "Nieuw lot trekken",
        "duplicate": "Dupliceren",
        "embed": "Insluiten",
        "fifteenMinutes": "15 minuten",
        "fiveMinutes": "5 minuten",
        "green": "Groen licht",
        "groupMode": "Groepswerk",
        "groupShuffle": "Groepen mixen",
        "insertTool": "Tool insluiten",
        "moveToPage": "Pagina {page}",
        "partnerMode": "Partnerwerk",
        "pause": "Pauze",
        "plenumMode": "Plenum",
        "red": "Rood licht",
        "reset": "Resetten",
        "resetTickets": "Alle loten terug in de pot",
        "rollDice": "Dobbelen",
        "showVideo": "Video tonen",
        "silenceMode": "Individueel werk",
        "start": "Starten",
        "stop": "Stoppen",
        "submitList": "Loten in de pot doen",
        "tenMinutes": "10 minuten",
        "uploadFile": "Bestand uploaden",
        "viewInSpotlight": "Kaart openen in spotlight-modus",
        "yellow": "Geel licht"
      },
      "components": {
        "dice": "Dobbelsteen",
        "embed": "Insluiten",
        "file": "Bestand",
        "group": "Groep",
        "image": "Afbeelding",
        "internalTool": "Tool",
        "lottery": "Lotenpot",
        "qrcode": "Link",
        "stoplights": "Verkeerslicht",
        "stopwatch": "Stopwatch",
        "text": "Tekst",
        "timer": "Timer",
        "video": "Video",
        "watch": "Klok",
        "workMode": "Sociale vorm"
      },
      "confirm": {
        "deleteCard": {
          "title": "Kaart verwijderen?",
          "text": "Deze actie kan niet ongedaan worden gemaakt. Alle inhoud van de huidige kaart wordt permanent verwijderd."
        },
        "deletePage": {
          "title": "Huidige pagina verwijderen?",
          "text": "Deze actie kan niet ongedaan worden gemaakt. Alle inhoud van de huidige pagina wordt permanent verwijderd."
        },
        "clearCanvas": {
          "title": "Alle tekeningen verwijderen?",
          "text": "Deze actie kan niet ongedaan worden gemaakt. Alle tekeningen op de huidige pagina worden permanent verwijderd."
        }
      },
      "flash": {
        "pageAdded": "Nieuwe pagina toegevoegd",
        "pageDeleted": "Pagina verwijderd",
        "pageUpdated": "Pagina bijgewerkt",
        "cardUpdateFailed": "Wijziging kon niet worden opgeslagen",
        "cardDeleteFailed": "Kaart kon niet worden verwijderd",
        "cardCreateFailed": "Kaart kon niet worden aangemaakt",
        "pageCreateFailed": "Pagina kon niet worden aangemaakt",
        "pageDeleteFailed": "Pagina kon niet worden verwijderd",
        "pageUpdateFailed": "Pagina kon niet worden opgeslagen",
        "pageReorderFailed": "Volgorde kon niet worden opgeslagen",
        "canvasSaveFailed": "Tekening kon niet worden opgeslagen",
        "saving": "Bezig met opslaan…"
      },
      "headings": {
        "classroomScreen": "Digitaal Schoolbord",
        "group": "Groep",
        "minScreenWidth": "Open het digitale schoolbord op een tablet of laptop"
      },
      "hints": {
        "embedCard": "Gebruik de toolmodule om fobizz-toolmaterialen in te sluiten. Zo wordt bij het kopiëren van deze leseenheid automatisch een eigen versie van de geïntegreerde materialen aangemaakt.",
        "itemId": "Zorg ervoor dat je de inhoud deelt met anderen, zodat deze correct kan worden weergegeven.",
        "itemType": "Als je dit schoolbordbeeld kopieert, wordt voor alle hier geïntegreerde inhoud automatisch een nieuwe versie aangemaakt. Zo kun je een bestaande leseenheid eenvoudig voor een andere doelgroep gebruiken.",
        "maxLengthTitle": "De titel is beperkt tot maximaal 45 tekens.",
        "minScreenWidth": "Om het digitale schoolbord te kunnen bekijken, heb je een resolutie van minimaal <strong>768&nbsp;px</strong> breedte nodig.",
        "noTicketsLeft": "De pot is leeg!"
      },
      "labels": {
        "diceCount": "Aantal dobbelstenen",
        "embed": "URL of iframe-snippet",
        "embedInternal": "Voorbeeld tonen",
        "groupCount": "Aantal groepen",
        "groupMode": "Groepswerk",
        "groupSize": "Groepsgrootte",
        "itemId": "Titel",
        "itemType": "Tool",
        "minutes": "Minuten",
        "partnerMode": "Partnerwerk",
        "plenumMode": "Plenum",
        "qrcodeInternal": "QR-code insluiten",
        "seconds": "Seconden",
        "shuffleCondition": "Voorwaarde voor groepsindeling",
        "silenceMode": "Individueel werk",
        "start": "Start",
        "title": "Titel voor je kaart",
        "continue": "Doorgaan",
        "pause": "Pauze"
      },
      "placeholders": {
        "enterItems": "Eén item per regel, bijvoorbeeld:\nMax\nMoritz",
        "enterText": "Tekst invoeren…",
        "enterUrl": "URL invoeren…",
        "enterUrlOrSnippet": "URL of iFrame-snippet invoeren…",
        "enterVideoUrl": "YouTube- of Vimeo-URL invoeren…",
        "names": "Eén naam per regel, bijvoorbeeld:\nMax\nMoritz",
        "title": "Titel...",
        "typeName": "Naam typen"
      },
      "validations": {
        "itemLocked": "Deze inhoud is zo ingesteld dat alleen de auteur de inhoud mag zien. Neem contact met hem/haar op om dit te wijzigen."
      },
      "tooltips": {
        "editMode": "Bewerken",
        "drawMode": "Tekenen"
      },
      "viewModes": {
        "tool": "Gereedschapsmodus",
        "canvas": "Tekeningmodus"
      }
    },
    "schoolClass": {
      "classroom": {
        "labels": {
          "activateControls": {
            "stop": "Stoppen"
          }
        }
      }
    }
  }
}
